module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_M1-c4ed9c7bf586fe6e9b52b286bc78bea9.png";